import { Role } from '../enums/role.enum';
import { decodeJwtPayload } from './jwt.util';

const SESSION_KEYS = ['token', 'refreshToken', 'userInfo', 'permissions', 'role', 'user', 'userDetails'];

/** Claims of the access token issued by velo-backend. */
export interface SessionClaims {
  sub: number;
  username: string;
  rol: Role;
  sessionId: number;
  type: 'access';
  exp: number;
}

export interface SessionUser {
  id: number;
  username: string;
  role: Role;
}

/** Persists the tokens of a successful login and returns the session user. */
export function saveSession(accessToken: string, refreshToken: string): SessionUser | null {
  const claims = decodeJwtPayload<SessionClaims>(accessToken);
  if (!claims) return null;
  const user: SessionUser = { id: claims.sub, username: claims.username, role: claims.rol };
  localStorage.setItem('token', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem('userInfo', JSON.stringify(user));
  return user;
}

/** Session user stored by the last login, or null. */
export function readSessionUser(): SessionUser | null {
  try {
    const raw = localStorage.getItem('userInfo');
    return raw ? (JSON.parse(raw) as SessionUser) : null;
  } catch {
    return null;
  }
}

/** Removes every piece of authentication state persisted in the browser. */
export function clearSession(): void {
  for (const key of SESSION_KEYS) {
    localStorage.removeItem(key);
  }
  sessionStorage.clear();
}
